export default __webpack_public_path__ + "static/media/t7.0be58178.png";